import type {
  Props as InputProps,
} from '@sgcmpteltd/uikit-react/components/input';
import type { SelectOption } from '@sgcmpteltd/uikit-react/components/select';

import {
  NEW_CARS_LISTING_FUEL_TYPE_DIESEL,
  NEW_CARS_LISTING_FUEL_TYPE_DIESEL_ELECTRIC,
  NEW_CARS_LISTING_FUEL_TYPE_ELECTRIC,
  NEW_CARS_LISTING_FUEL_TYPE_PETROL,
  NEW_CARS_LISTING_FUEL_TYPE_PETROL_ELECTRIC,
} from '@/apis/server/new-car/v1/constants';
import {
  ENGINE_CAP_SELECT_OPTION_VALUE_661_TO_1600,
  ENGINE_CAP_SELECT_OPTION_VALUE_1601_TO_2000,
  ENGINE_CAP_SELECT_OPTION_VALUE_2001_TO_3000,
  ENGINE_CAP_SELECT_OPTION_VALUE_LESS_THAN_661,
  ENGINE_CAP_SELECT_OPTION_VALUE_MORE_THAN_3000,
  SEARCH_INPUT_PLACEHOLDER,
} from '@/components/search-filter/constants';
import type {
  SearchFilterTypeConfigItem,
} from '@/components/search-filter/types';
import {
  FILTER_TYPE_NAME_CATEGORY,
  FILTER_TYPE_NAME_COE_TYPE,
  FILTER_TYPE_NAME_COUNTRY,
  FILTER_TYPE_NAME_DEALER_TYPE,
  FILTER_TYPE_NAME_DEPRECIATION,
  FILTER_TYPE_NAME_DRIVE_RANGE,
  FILTER_TYPE_NAME_ENERGY_CONSUPTION,
  FILTER_TYPE_NAME_ENGINE_CAP,
  FILTER_TYPE_NAME_FUEL_CONSUMPTION,
  FILTER_TYPE_NAME_FUEL_TYPE,
  FILTER_TYPE_NAME_OMV,
  FILTER_TYPE_NAME_POWER_OUTPUT,
  FILTER_TYPE_NAME_PRICE_RANGE,
  FILTER_TYPE_NAME_TRANSIMISSION,
  VEHICLE_NAME_ALL_COMMERCIAL_VEHICLES,
  VEHICLE_NAME_ELECTRIC_CARS,
  VEHICLE_NAME_HATCHBACK,
  VEHICLE_NAME_HYBRID_CARS,
  VEHICLE_NAME_LUXURY_SEDAN,
  VEHICLE_NAME_MID_SIZED_SEDAN,
  VEHICLE_NAME_MPV,
  VEHICLE_NAME_SPORTS_CARS,
  VEHICLE_NAME_STATIONWAGON,
  VEHICLE_NAME_SUV,
  VEHICLE_VALUE_ALL_COMMERCIAL_VEHICLES,
  VEHICLE_VALUE_ELECTRIC_CARS,
  VEHICLE_VALUE_HATCHBACK,
  VEHICLE_VALUE_HYBRID_CARS,
  VEHICLE_VALUE_LUXURY_SEDAN,
  VEHICLE_VALUE_MID_SIZED_SEDAN,
  VEHICLE_VALUE_MPV,
  VEHICLE_VALUE_SPORTS_CARS,
  VEHICLE_VALUE_STATIONWAGON,
  VEHICLE_VALUE_SUV,
} from '@/constants/global';

import type { FilterValue } from './filter-label-list/types';
import type { CategoryInput, CheckboxOption } from './filter-modal/types';

export const createFilterValue: Record<string, FilterValue> = {
  omv: {
    name: FILTER_TYPE_NAME_OMV,
    type: 'choice',
    optionValue: {
      text: '',
      value: '',
    },
    unit: {
      type: 'prefix',
      value: '$',
    },
    inputValue: '',
  },
  energy_consumption: {
    name: FILTER_TYPE_NAME_ENERGY_CONSUPTION,
    type: 'choice',
    optionValue: {
      text: '',
      value: '',
    },
    unit: {
      type: 'suffix',
      value: 'kWh',
    },
    inputValue: '',
  },
  power_output: {
    name: FILTER_TYPE_NAME_POWER_OUTPUT,
    type: 'choice',
    optionValue: {
      text: '',
      value: '',
    },
    unit: {
      type: 'suffix',
      value: 'bhp',
    },
    inputValue: '',
  },
  fuel_economy: {
    name: FILTER_TYPE_NAME_FUEL_CONSUMPTION,
    type: 'choice',
    optionValue: {
      text: '',
      value: '',
    },
    unit: {
      type: 'suffix',
      value: 'km/L',
    },
    inputValue: '',
  },
  price_range: {
    name: FILTER_TYPE_NAME_PRICE_RANGE,
    type: 'range',
    lowerValue: {
      text: 'Lowest',
      value: '',
    },
    upperValue: {
      text: 'Highest',
      value: '',
    },
  },
  depreciation: {
    name: FILTER_TYPE_NAME_DEPRECIATION,
    type: 'range',
    lowerValue: {
      text: 'Lowest',
      value: '',
    },
    upperValue: {
      text: 'Highest',
      value: '',
    },
  },
  drive_range: {
    name: FILTER_TYPE_NAME_DRIVE_RANGE,
    type: 'range',
    lowerValue: {
      text: 'Lowest',
      value: '',
    },
    upperValue: {
      text: 'Highest',
      value: '',
    },
  },
  transmission: {
    name: FILTER_TYPE_NAME_TRANSIMISSION,
    type: 'select',
    optionValue: {
      text: '',
      value: '',
    },
  },
  engine_capacity: {
    name: FILTER_TYPE_NAME_ENGINE_CAP,
    type: 'select',
    optionValue: {
      text: '',
      value: '',
    },
  },
  fuel_type: {
    name: FILTER_TYPE_NAME_FUEL_TYPE,
    type: 'select',
    optionValue: {
      text: '',
      value: '',
    },
  },
  category: {
    name: FILTER_TYPE_NAME_CATEGORY,
    type: 'select',
    optionValue: {
      text: '',
      value: '',
    },
  },
  dealer_type: {
    name: FILTER_TYPE_NAME_DEALER_TYPE,
    type: 'select',
    optionValue: {
      text: '',
      value: '',
    },
  },
  coe_category: {
    name: FILTER_TYPE_NAME_COE_TYPE,
    type: 'select',
    optionValue: {
      text: '',
      value: '',
    },
  },
  country: {
    name: FILTER_TYPE_NAME_COUNTRY,
    type: 'select',
    optionValue: {
      text: '',
      value: '',
    },
  },
};

export const vehicleTypeCheckboxOptionList: CheckboxOption[] = [
  { name: VEHICLE_NAME_SUV, value: VEHICLE_VALUE_SUV },
  { name: VEHICLE_NAME_MPV, value: VEHICLE_VALUE_MPV },
  { name: VEHICLE_NAME_HYBRID_CARS, value: VEHICLE_VALUE_HYBRID_CARS },
  { name: VEHICLE_NAME_ELECTRIC_CARS, value: VEHICLE_VALUE_ELECTRIC_CARS },
  { name: VEHICLE_NAME_LUXURY_SEDAN, value: VEHICLE_VALUE_LUXURY_SEDAN },
  { name: VEHICLE_NAME_MID_SIZED_SEDAN, value: VEHICLE_VALUE_MID_SIZED_SEDAN },
  { name: VEHICLE_NAME_SPORTS_CARS, value: VEHICLE_VALUE_SPORTS_CARS },
  { name: VEHICLE_NAME_HATCHBACK, value: VEHICLE_VALUE_HATCHBACK },
  { name: VEHICLE_NAME_STATIONWAGON, value: VEHICLE_VALUE_STATIONWAGON },
  {
    name: VEHICLE_NAME_ALL_COMMERCIAL_VEHICLES,
    value: VEHICLE_VALUE_ALL_COMMERCIAL_VEHICLES,
  },
];

export const priceRangeSelectOptionList: readonly SelectOption[] = [
  { value: 70000, text: '$70,000' },
  { value: 80000, text: '$80,000' },
  { value: 90000, text: '$90,000' },
  { value: 100000, text: '$100,000' },
  { value: 110000, text: '$110,000' },
  { value: 120000, text: '$120,000' },
  { value: 130000, text: '$130,000' },
  { value: 140000, text: '$140,000' },
  { value: 150000, text: '$150,000' },
  { value: 160000, text: '$160,000' },
  { value: 170000, text: '$170,000' },
  { value: 180000, text: '$180,000' },
  { value: 190000, text: '$190,000' },
  { value: 200000, text: '$200,000' },
  { value: 210000, text: '$210,000' },
  { value: 220000, text: '$220,000' },
  { value: 230000, text: '$230,000' },
  { value: 240000, text: '$240,000' },
  { value: 250000, text: '$250,000' },
  { value: 300000, text: '$300,000' },
  { value: 350000, text: '$350,000' },
  { value: 400000, text: '$400,000' },
  { value: 500000, text: '$500,000' },
  { value: 600000, text: '$600,000' },
  { value: 700000, text: '$700,000' },
];

export const depreciationRangeSelectOptionList: readonly SelectOption[] = [
  { value: 7000, text: '$7,000/yr' },
  { value: 8000, text: '$8,000/yr' },
  { value: 9000, text: '$9,000/yr' },
  { value: 10000, text: '$10,000/yr' },
  { value: 11000, text: '$11,000/yr' },
  { value: 12000, text: '$12,000/yr' },
  { value: 13000, text: '$13,000/yr' },
  { value: 14000, text: '$14,000/yr' },
  { value: 15000, text: '$15,000/yr' },
  { value: 16000, text: '$16,000/yr' },
  { value: 17000, text: '$17,000/yr' },
  { value: 18000, text: '$18,000/yr' },
  { value: 19000, text: '$19,000/yr' },
  { value: 20000, text: '$20,000/yr' },
  { value: 21000, text: '$21,000/yr' },
  { value: 22000, text: '$22,000/yr' },
  { value: 23000, text: '$23,000/yr' },
  { value: 24000, text: '$24,000/yr' },
  { value: 25000, text: '$25,000/yr' },
  { value: 26000, text: '$26,000/yr' },
  { value: 27000, text: '$27,000/yr' },
  { value: 28000, text: '$28,000/yr' },
  { value: 29000, text: '$29,000/yr' },
  { value: 30000, text: '$30,000/yr' },
  { value: 40000, text: '$40,000/yr' },
  { value: 50000, text: '$50,000/yr' },
  { value: 60000, text: '$60,000/yr' },
];

export const countrySelectOptionList: readonly SelectOption[] = [
  { text: 'American', value: 'American' },
  { text: 'Chinese', value: 'Chinese' },
  { text: 'Continental', value: 'Continental' },
  { text: 'Japanese', value: 'Japanese' },
  { text: 'Korean', value: 'Korean' },
  { text: 'Malaysian', value: 'Malaysian' },
  { text: 'Others', value: 'Others' },
];

export const searchBarSearchOptionConfig: InputProps = {
  placeholder: SEARCH_INPUT_PLACEHOLDER,
};

export const searchBarSelectOptionsConfig:
SearchFilterTypeConfigItem[] = [];

export const filterModalCategoriesConfig: CategoryInput[] = [
  // uncomment until listing releases
  // {
  //   name: 'Vehicle Type',
  //   type: 'checkbox',
  //   checkboxOptions: vehicleTypeCheckboxOptionList,
  //   allCheckbox: 'All Vehicles',
  // },
  {
    name: FILTER_TYPE_NAME_PRICE_RANGE,
    type: 'range',
    lowerSelectOption: {
      optionList: priceRangeSelectOptionList,
      placeholder: {
        text: 'Lowest',
        value: '',
      },
    },
    upperSelectOption: {
      optionList: priceRangeSelectOptionList,
      placeholder: {
        text: 'Highest',
        value: '',
      },
    },
  },
  {
    name: FILTER_TYPE_NAME_DEPRECIATION,
    type: 'range',
    lowerSelectOption: {
      optionList: depreciationRangeSelectOptionList,
      placeholder: {
        text: 'Lowest',
      },
    },
    upperSelectOption: {
      optionList: depreciationRangeSelectOptionList,
      placeholder: {
        text: 'Highest',
      },
    },
  },
];

export const filterModalAccordionCategoriesConfig: CategoryInput[] = [
  {
    name: FILTER_TYPE_NAME_CATEGORY,
    type: 'select',
    selectOption: {
      optionList: [
        { text: 'Authorised Distributor', value: 'ad' },
        { text: 'Parallel Importer', value: 'pi' },
        { text: 'Cat A COE', value: 'a' },
        { text: 'Cat B COE', value: 'b' },
      ],
      placeholder: {
        text: 'Any',
      },
    },
  },
  {
    name: FILTER_TYPE_NAME_FUEL_TYPE,
    type: 'select',
    selectOption: {
      optionList: [
        {
          text: 'Petrol',
          value: NEW_CARS_LISTING_FUEL_TYPE_PETROL,
        },
        {
          text: 'Diesel',
          value: NEW_CARS_LISTING_FUEL_TYPE_DIESEL,
        },
        {
          text: 'Petrol-Electric',
          value: NEW_CARS_LISTING_FUEL_TYPE_PETROL_ELECTRIC,
        },
        {
          text: 'Diesel-Electric',
          value: NEW_CARS_LISTING_FUEL_TYPE_DIESEL_ELECTRIC,
        },
        {
          text: 'Electric',
          value: NEW_CARS_LISTING_FUEL_TYPE_ELECTRIC,
        },
      ],
      placeholder: {
        text: 'Any',
      },
    },
  },
  {
    name: FILTER_TYPE_NAME_FUEL_CONSUMPTION,
    type: 'choice',
    selectOption: {
      optionList: [
        { text: 'Less than', value: '<' },
        { text: 'More than', value: '>' },
        { text: 'Equal to', value: '=' },
      ],
      placeholder: {
        text: 'Any',
      },
    },
    inputOption: {
      suffix: 'km/L',
      type: 'number',
    },
  },
  {
    name: FILTER_TYPE_NAME_ENERGY_CONSUPTION,
    type: 'choice',
    selectOption: {
      optionList: [
        { text: 'Less than', value: '<' },
        { text: 'More than', value: '>' },
        { text: 'Equal to', value: '=' },
      ],
      placeholder: {
        text: 'Any',
      },
    },
    inputOption: {
      suffix: 'kWh',
      type: 'number',
    },
  },
  {
    name: FILTER_TYPE_NAME_DRIVE_RANGE,
    type: 'range',
    lowerSelectOption: {
      optionList: [
        { text: '200 km', value: 200 },
        { text: '250 km', value: 250 },
        { text: '300 km', value: 300 },
        { text: '350 km', value: 350 },
        { text: '400 km', value: 400 },
        { text: '450 km', value: 450 },
        { text: '500 km', value: 500 },
        { text: '550 km', value: 550 },
      ],
      placeholder: {
        text: 'Lowest',
      },
    },
    upperSelectOption: {
      optionList: [
        { text: '200 km', value: 200 },
        { text: '250 km', value: 250 },
        { text: '300 km', value: 300 },
        { text: '350 km', value: 350 },
        { text: '400 km', value: 400 },
        { text: '450 km', value: 450 },
        { text: '500 km', value: 500 },
        { text: '550 km', value: 550 },
      ],
      placeholder: {
        text: 'Highest',
      },
    },
  },
  {
    name: FILTER_TYPE_NAME_ENGINE_CAP,
    type: 'select',
    selectOption: {
      optionList: [
        {
          value: ENGINE_CAP_SELECT_OPTION_VALUE_LESS_THAN_661,
          text: '< 661cc',
        },
        {
          value: ENGINE_CAP_SELECT_OPTION_VALUE_661_TO_1600,
          text: '661cc - 1,600cc',
        },
        {
          value: ENGINE_CAP_SELECT_OPTION_VALUE_1601_TO_2000,
          text: '1,601cc - 2,000cc',
        },
        {
          value: ENGINE_CAP_SELECT_OPTION_VALUE_2001_TO_3000,
          text: '2,001cc - 3,000cc',
        },
        {
          value: ENGINE_CAP_SELECT_OPTION_VALUE_MORE_THAN_3000,
          text: '> 3,000cc',
        },
      ],
      placeholder: {
        text: 'Any',
      },
    },
  },
  {
    name: FILTER_TYPE_NAME_POWER_OUTPUT,
    type: 'choice',
    selectOption: {
      optionList: [
        { text: 'Less than', value: '<' },
        { text: 'More than', value: '>' },
        { text: 'Equal to', value: '=' },
      ],
      placeholder: {
        text: 'Any',
      },
    },
    inputOption: {
      suffix: 'bhp',
    },
  },
  {
    name: FILTER_TYPE_NAME_TRANSIMISSION,
    type: 'select',
    selectOption: {
      optionList: [
        { text: 'Manual', value: 'M' },
        { text: 'Auto', value: 'A' },
      ],
      placeholder: {
        text: 'Any',
      },
    },
  },
  {
    name: FILTER_TYPE_NAME_COUNTRY,
    type: 'select',
    selectOption: {
      optionList: countrySelectOptionList,
      placeholder: {
        text: 'Any',
      },
    },
  },
  {
    name: FILTER_TYPE_NAME_OMV,
    type: 'choice',
    selectOption: {
      optionList: [
        { text: 'Less than', value: '<' },
        { text: 'More than', value: '>' },
        { text: 'Equal to', value: '=' },
      ],
      placeholder: {
        text: 'Any',
      },
    },
    inputOption: {
      prefix: '$',
      type: 'number',
    },
  },
];
